<div class="wrapper wrapper--{{ color }}">
  <!-- Version number get set by build-script (config/build/set-version.ps1) and does not work for local development -->
  <div class="top-menu-left-side">
    <button
      type="button"
      mat-icon-button
      class="top-level-mobile-toggle"
      (click)="toggleTopLevelMenu()"
      [attr.aria-expanded]="topLevelMenuOpen()"
      [matTooltip]="'top-level-side-menu.toggle-menu' | translate"
      [attr.aria-label]="'top-level-side-menu.toggle-menu' | translate">
      <mat-icon>menu</mat-icon>
    </button>
    <a class="triggerbee-logo-container" (click)="setMenuForUserApp()" [routerLink]="['/']" [title]="version">
      <img class="triggerbee-logo triggerbee-logo--large" src="/assets/img/triggerbee-logo-black.svg" />
      <img class="triggerbee-logo triggerbee-logo--small" src="/assets/img/bullet-black-triggerbee.png" />
    </a>
    <span class="top-menu-page-title" [class.top-menu-page-title--visible]="pageTitleVisible()" [attr.aria-hidden]="!pageTitleVisible()">
      {{ pageTitle() }}
    </span>
  </div>

  <ul class="header-list top-menu-right-side">
    @if (settings?.adminToggle) {
      <li class="header-list__item hide-on-mobile">
        <app-customer-selector class="header-customer-selector"></app-customer-selector>
      </li>
    }

    <li class="header-list__item">
      <app-site-selector class="header-site-selector"></app-site-selector>
    </li>

    @if (agentPanelEnabled()) {
      <li class="header-list__item header-list__item--agent-launcher">
        <app-agent-launcher-button></app-agent-launcher-button>
      </li>
    }

    <li class="header-list__item">
      <app-knowledge-notification-bell></app-knowledge-notification-bell>
    </li>
  </ul>
</div>
